module.exports = __webpack_public_path__ + "static/img/Banner_PS_Ready.db22ed0.jpg";